export { formatDateTime } from '~/app/utils/format-date-time';

export function formatJson(value: Record<string, unknown> | null): string {
  if (!value) {
    return '{}';
  }

  return JSON.stringify(value, null, 2);
}
